import {useEffect, useState, useCallback} from 'react'
import Alert from 'react-bootstrap/Alert'
import usePluginsSpace from '../../../../app/hooks/usePluginSpace'
import useAuth from '../../../../app/hooks/useAuth'

function AlertStatusPluginSpace() {
  const [show, setShow] = useState(false)
  const {loginInfo} = useAuth()
  const {getPluginSpace} = usePluginsSpace()

  const showAlert = useCallback(async () => {
    try {
      // Não forçar chamada à API aqui: usar cache/localStorage primeiro
      const pluginSpace = await getPluginSpace(false, true)

      // 🛠️ CORREÇÃO: Verificar se pluginSpace existe e tem propriedade status
      if (pluginSpace && typeof pluginSpace === 'object' && 'status' in pluginSpace) {
        setShow(!pluginSpace.status)
      } else {
        // Se não há dados válidos do pluginSpace, não mostrar alerta
        setShow(false)
      }
    } catch (error) {
      console.error('Erro ao carregar pluginSpace:', error)
      // Em caso de erro, não mostrar o alerta
      setShow(false)
    }
  }, [getPluginSpace])

  useEffect(() => {
    showAlert()
  }, [loginInfo.pluginspaceId])

  return (
    <>
      {show && (
        <Alert
          variant='warning fixed-top d-flex justify-content-center rounded-0'
          onClose={() => setShow(false)}
          dismissible
        >
          <span className='text-center'>
            Sua conta se encontra desativada, entre em contato com o responsável pela sua conta!
          </span>
        </Alert>
      )}
    </>
  )
}

export {AlertStatusPluginSpace}
